module.exports = __webpack_public_path__ + "img/inboxes.8ad25aca.svg";